/**
 * App-download bar experiment — sticky A/B/C assignment.
 *
 * Why a local pick instead of a PostHog feature flag:
 * PostHog runs with `persistence: 'memory'` until cookie consent (src/index.js),
 * so flag values are not reliably available on the first paint for anonymous
 * visitors. Picking locally means the bar never flickers and the test works
 * whether or not analytics consent exists.
 *
 * The stored value is a UI preference ("which bar do I show"), not an
 * identifier, so it lives in localStorage with no personal data.
 *
 * Force a variant for QA / preview: ?banner=purple | glass | dock
 * Re-randomise:                              ?banner=reset
 */

import { assignExperimentVariant } from "./experimentAssignment";

export const BANNER_VARIANTS = ["purple", "glass", "dock"];

/**
 * Returns the variant this browser should see, and persists the decision so
 * the same visitor keeps seeing the same bar (that is what makes the CTR
 * comparison meaningful).
 */
export function assignBannerVariant() {
  return assignExperimentVariant({
    id: "app_banner",
    param: "banner",
    variants: BANNER_VARIANTS,
    // Preserve existing assignments when moving onto the shared helper.
    storageKey: "22n_app_banner_variant",
  });
}

export default assignBannerVariant;
